export const registerUser = {
  email: 'Email',
  password: 'Password',
};

export const createUser = {
  username: 'Username',
  password: 'Password',
  email: 'Email',
  enabled: 'Enabled',
  internal: 'Internal',
  admin: 'Admin',
};

export const editUser = {
  ...createUser,
  password: 'Change Password',
};

export const changePassword = {
  oldPassword: 'Current Password',
  newPassword: 'New Password',
};

export const userProfile = {
  fullName: 'Full Name',
  email: 'Email',
  jobRole: 'Role',
  companyName: 'Company Name',
};

export const userSettings = {
  hasCostarLicense: 'Costar License',
};

export const notificationSettings = {
  emailNotifications: 'Email Notifications',
};

export const login = {
  email: 'Email',
  password: 'Password',
};

export const passwordReset = {
  email: 'Email',
  newPassword: 'New Password',
};
